<template>
  <div class="Notice">
    <navigator :title="serviceMsg.serviceName" :routePath='"/"'></navigator>
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="list">
        <Item v-for='(item, index) in productionList' :key='index' :info='item'></Item>
      </div>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Item from './child/Item';


export default {
  data() {
    return {
      productionList : [],
      condition: {
        currPage: 1,
        pageRows: 10,
      },
      total: 0,
      loading: false,
      finished: false,
      serviceMsg: {},
    };
  },
  methods: {
    loadMore() {
      console.log(123);
      if (this.productionList.length >= this.total) {
        return;
      }
      this.loading = true;
      this.condition.currPage++;
      this.getList();
    },
    getList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/products/roadshow/list`, {
        parkId: this.currentParkId,
        ...this.condition,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.productionList = this.productionList.concat(tempArr);
          this.finished = this.productionList.length >= this.total ? true : false;
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'parkServiceList']),
  },
  components: { Item },
  created() {
    this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 7;
    });
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.list{
  padding: .32rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/production/Production.vue